// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Components
import ResetButton from './reset-button';
import SubmitButton from './submit-button';

// Styles
import './form-buttons.scss';

export default class FormButtons extends Component {
    getClass() {
        const {className} = this.props;

        return classnames('form-buttons', className);
    }

    render() {
        const {cancel, noLabel, onReset, type} = this.props;

        return (
            <span className={this.getClass()}>
                {!noLabel ? <label className="form-buttons--label" /> : null}
                <ResetButton className="buttons--reset" onReset={onReset}>
                    {cancel ? 'cancel' : 'clear'}
                </ResetButton>
                <SubmitButton label={type} />
            </span>
        );
    }
}

FormButtons.propTypes = {
    cancel: PropTypes.bool,
    className: PropTypes.string,
    noLabel: PropTypes.bool,
    onReset: PropTypes.func,
    type: PropTypes.string,
};
